import React, { useState } from 'react'
import { useEffect } from 'react';
import { Spinner } from 'reactstrap'
import Imgspinner from "../../assets/images/spinner.gif"

const BlankPage = () => {

    const [Data, setData] = useState([])

    const getData = async () => {
        const sendData = {
            OrgId: Number(1)

        }
       // //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Showdata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setData(data.address1)
                    ////console.log(data)

                })


    };

    useEffect(() => {
        getData()
    },[])

    const mystyle = {
        height: "100%",
        width: "100%",
        display: "flex",
        margin: "15rem",
        position: "relative",
        left: "15rem"

    }
    const mystyle1 = {
        
        marginLeft:"25.5rem"

    }
    const text = {
        color: "red",
          marginTop: "-10.5rem",
    }
    return (
        <>   <div style={mystyle1}><img src={Imgspinner} alt="loading..." /></div>
            <div style={mystyle}>
               
                <h1 style={text}>{Data}</h1>
            </div>

        </>  
    )
}
export default BlankPage